import { z } from 'zod';

/**
 * 업로드 폼 zod 스키마 — react-hook-form resolver 연결용
 * §3.2 기반:
 *   - markdownText: 필수/비어있지 않음 (서버 @NotBlank)
 *   - docVersion: 선택, 최대 64자
 *   - sourceCommit: 선택, 7~40자 16진수 (git SHA)
 */
export const uploadDevStandardsSchema = z.object({
  markdownText: z
    .string()
    .min(1, { message: '마크다운 본문을 입력하거나 파일을 선택하세요.' })
    .max(5_000_000, { message: '최대 5MB (5,000,000자) 를 초과했습니다.' }),

  docVersion: z
    .string()
    .max(64, { message: '버전 문자열은 최대 64자입니다.' })
    .optional()
    .or(z.literal('')),

  sourceCommit: z
    .string()
    .regex(/^[0-9a-fA-F]{7,40}$/, { message: '커밋 해시는 7~40자 16진수여야 합니다.' })
    .optional()
    .or(z.literal('')),
});

export type UploadDevStandardsFormValues = z.infer<typeof uploadDevStandardsSchema>;
